// extracted by mini-css-extract-plugin
module.exports = {"container":"CloudWordBox__container","head":"CloudWordBox__head","tagContainer":"CloudWordBox__tagContainer","tag":"CloudWordBox__tag","fadeIn":"CloudWordBox__fadeIn"};